import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/constants";
import StatusBadge from "@/components/admin/StatusBadge";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = stats
    ? [
        { label: "Nouvelles demandes", value: stats.nouvelles, cls: "bg-sky-50 text-sky-900 border-sky-200", testid: "stat-nouvelles" },
        { label: "À traiter", value: stats.a_traiter, cls: "bg-amber-50 text-amber-900 border-amber-200", testid: "stat-a-traiter" },
        { label: "En cours", value: stats.en_cours, cls: "bg-blue-50 text-blue-900 border-blue-200", testid: "stat-en-cours" },
        { label: "Terminées", value: stats.terminees, cls: "bg-green-50 text-green-900 border-green-200", testid: "stat-terminees" },
        { label: "Réalisations publiées", value: stats.realisations_publiees, cls: "bg-mint text-forest border-pine/20", testid: "stat-realisations" },
      ]
    : [];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display font-semibold text-2xl sm:text-3xl text-ink">Tableau de bord</h1>
      <p className="mt-1 text-sm text-muted2">Vue d'ensemble de l'activité MARY SERVICES.</p>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {(stats ? cards : Array.from({ length: 5 })).map((c, i) =>
          stats ? (
            <div key={c.label} data-testid={c.testid} className={`rounded-2xl border p-5 ${c.cls}`}>
              <p className="font-display font-semibold text-3xl">{c.value}</p>
              <p className="mt-1 text-xs font-medium opacity-80">{c.label}</p>
            </div>
          ) : (
            <div key={i} className="rounded-2xl border border-line bg-white p-5 h-[92px] animate-pulse" />
          )
        )}
      </div>

      <div className="mt-10 flex items-center justify-between">
        <h2 className="font-display font-semibold text-xl text-ink">Dernières demandes</h2>
        <Link to="/admin/demandes" className="text-sm font-semibold text-forest hover:text-pine inline-flex items-center gap-1" data-testid="dashboard-all-quotes">
          Tout voir <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="mt-4 rounded-2xl bg-white border border-line overflow-hidden">
        {!stats ? (
          <div className="p-8 text-center text-muted2 text-sm">Chargement…</div>
        ) : stats.dernieres_demandes.length === 0 ? (
          <div className="p-10 text-center" data-testid="dashboard-empty">
            <Inbox className="h-8 w-8 text-line mx-auto" />
            <p className="mt-3 text-sm text-muted2">Aucune demande pour le moment. Les nouvelles demandes de devis apparaîtront ici.</p>
          </div>
        ) : (
          <ul className="divide-y divide-line">
            {stats.dernieres_demandes.map((q) => (
              <li key={q.id}>
                <Link
                  to={`/admin/demandes/${q.id}`}
                  data-testid={`dashboard-quote-${q.id}`}
                  className="flex flex-wrap items-center gap-x-4 gap-y-1.5 px-5 py-4 hover:bg-cream/60 transition-colors"
                >
                  <span className="font-semibold text-ink text-sm min-w-[120px]">{q.name}</span>
                  <span className="text-xs text-muted2">{q.need_type}</span>
                  <span className="text-xs text-muted2 ml-auto hidden sm:block">{fmtDate(q.created_at)}</span>
                  <StatusBadge status={q.status} />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
